import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
   urlWebapi = 'https://webapi.clinique-procrea.com/';
  constructor() { }
}
